import { useEffect, useState } from "react";
import { Api } from "../../lib/api";

/** Poll Stripe checkout status until paid or 10 attempts (~15s). */
export default function useStripePolling(sid) {
  const [status, setStatus] = useState(sid ? "checking" : "confirmed");

  useEffect(() => {
    if (!sid) return;
    let stopped = false;
    let attempts = 0;
    const tick = async () => {
      try {
        const s = await Api.checkoutStatus(sid);
        if (stopped) return;
        setStatus(s.payment_status || s.status || "pending");
        if (++attempts < 10 && s.payment_status !== "paid") {
          setTimeout(tick, 1500);
        }
      } catch {
        if (!stopped) setStatus("confirmed");
      }
    };
    tick();
    return () => {
      stopped = true;
    };
  }, [sid]);

  return status;
}
